import { ReactNode } from "react";

interface AppleSectionProps {
  children: ReactNode;
  background?: "white" | "black" | "gray";
  padding?: "normal" | "large";
  id?: string;
}

const AppleSection = ({ 
  children, 
  background = "white",
  padding = "large",
  id
}: AppleSectionProps) => {
  const bgClass = {
    white: "bg-white dark:bg-black",
    black: "bg-black dark:bg-white",
    gray: "bg-gray-50 dark:bg-gray-950"
  }[background];

  const paddingClass = padding === "large" 
    ? "py-16 md:py-24 lg:py-32" 
    : "py-12 md:py-16 lg:py-24";

  return (
    <section id={id} className={`${bgClass} ${paddingClass}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        {children}
      </div>
    </section>
  );
};

export default AppleSection;
